import { useVoiceDeviceContext } from "@/app/_module/contexts/VoiceDeviceProvider";

/**
 * Hook to access Twilio Device functionality
 * Must be used within TwilioDeviceProvider
 */
export const useTwilioDevice = () => {
  return useVoiceDeviceContext();
};
